<template>
  <section class="t-card" :class="[{ 't-card--inline': inline }]">
    <header class="t-card__header" v-if="$slots.header"><slot name="header"></slot></header>
    <slot></slot>
    <footer class="t-card__footer" v-if="$slots.footer"><slot name="footer"></slot></footer>
  </section>
</template>

<script>
export default {
  name: 't-card',

  props: {
    inline: Boolean,
  },
};
</script>
